import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Avatar from 'src/componentes/avatar';
import LoadingContainer from 'src/componentes/loading-container';
import Spinner from 'src/componentes/spinner';
import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/errorHandler';
import { capitalizeFirstLetter } from 'src/utils/string';

const PerfilDossie = ({ colaboradorId }) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  const [colaborador, setColaborador] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getPerfil();
  }, [colaboradorId]);

  const getPerfil = async () => {
    try {
      setIsLoading(true);
      const response = await http.post(
        'DossieColaborador/ObterPerfilColaborador',
        {
          colaboradorId,
        }
      );
      if (response.data) {
        setColaborador(response.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      errorHandler(error);
    }
  };

  return (
    <div className="mb-3 px-3">
      <div
        className="py-4 px-6 rounded-xl bg-primary-50"
        style={{ width: 400, height: 600 }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100 ml-5">
            <Spinner size={100} />
          </div>
        ) : (
          <>
            <div className="d-flex mb-5 justify-content-center">
              <Avatar
                id="avatar"
                size={250}
                foto={colaborador?.fotoArquivo}
                label={colaborador?.nome}
                showLabel={false}
                labelSize={70}
              />
            </div>
            <div>
              <div className="font-weight-bolder" style={{ fontSize: '24px' }}>
                {colaborador?.nome}
              </div>
              <div style={{ fontSize: '20px' }}>{colaborador?.cargo?.nome}</div>
              <p></p>
              <p style={{ fontSize: '16px' }}>
                {`${capitalizeFirstLetter(
                  intl.formatMessage({ id: 'area' }, { area: resources.area })
                )}: `}
                <span className="font-weight-bolder">
                  {colaborador?.area?.nome}
                </span>
              </p>
              <p style={{ fontSize: '16px' }}>
                {`${capitalizeFirstLetter(
                  intl.formatMessage({ id: 'lider' })
                )}: `}
                <span className="font-weight-bolder">
                  {colaborador?.lider?.nome}
                </span>
              </p>
              {colaborador?.gestorMatricial && (
                <p style={{ fontSize: '16px' }}>
                  {`${capitalizeFirstLetter(
                    intl.formatMessage({ id: 'gestorMatricial' })
                  )}: `}
                  <span className="font-weight-bolder">
                    {colaborador?.gestorMatricial?.nome}
                  </span>
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PerfilDossie;
